export default __webpack_public_path__ + "static/media/web-platforms-blue.89be3924.svg";